export function getAdminAlert() {
  const S3_ALERT_URL = 'https://s3.amazonaws.com/voltron-ui/alert/alert.txt';
  return fetch(S3_ALERT_URL)
    .then(res => {
      if (!res.ok) return Promise.reject(res.statusText);
      return res.text();
    });
}



// WEBPACK FOOTER //
// ./src/api/adminAlert.js